function NextArrowIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='9'
      height='17'
      fill='none'
      viewBox='0 0 9 17'
      className='viewer-icon'
    >
      <path
        fill='#06F'
        d='M1 16.5a.999.999 0 01-.707-1.707L6.586 8.5.293 2.207A.999.999 0 111.707.793l7 7a.999.999 0 010 1.414l-7 7A.997.997 0 011 16.5z'
      />
    </svg>
  );
}

export default NextArrowIcon;
